import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import "../App.css";
import { apiPostPublic} from "../utils/api";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(0); // countdown timer

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      // Make API call to register.php
      const response = await apiPostPublic("send_reset_password.php", {
        email: email,
      });


      if (response.result === 1) {
        setMessage("Link lupa password telah dikirim. Mohon cek email kamu (Termasuk folder spam).");
        setCountdown(100); // start countdown
      } else {
        setError(response.message || "Gagal mengirim link lupa password, coba lagi nanti.");
      }
    } catch (error) {
      setError("Terjadi kesalahan, coba lagi nanti.");
    } finally {
      setLoading(false);
    }
  };

  // Countdown logic
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Reset Password</h2>
        <form onSubmit={handleSubmit} className="form-container">
          <input
            type="email"
            placeholder="Masukkan email kamu"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="primary-button"
            disabled={loading || countdown > 0}
          >
            {loading
              ? "Mengirim..."
              : countdown > 0
              ? `Kirim ulang dalam ${countdown}s`
              : "Kirim link reset password"}
          </button>
        </form>

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        <p className="form-footer">
          Ingat password? <Link to="/" className="link">Login</Link>
        </p>
        <div className="copyright">© MySite.co.id 2025</div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
